<template>
  <div>
    <b-card no-body class="card-transparent-background" :class="{ 'my-0 p-0': type == 'view' || type == 'edit' }">
      <b-card-header class="p-0" v-if="type == 'register'">
        <b-card-title class="card-title-form-steps-garden-help">
          Sign Up Now
        </b-card-title>
        <b-card-sub-title class="card-subtitle-form-steps-garden-help">
          Please provide us with your details to start working now
        </b-card-sub-title>
      </b-card-header>
      <b-card-body class="p-0">
        <b-card no-body :class="{ 'card-transparent-background my-0 pt-0': type == 'view' || type == 'edit' }">
          <b-card-body :class="{
            'px-2 py-4': type == 'register',
            'p-0': type == 'view' || type == 'edit',
          }">
            <div class="container" :class="{
              'mx-0': type == 'view' || type == 'edit',
            }">
              <b-row>
                <b-col sm="12">
                  <b-form-group class="form-group-garden-help"
                                :label="'Business Name'" label-for="legal_company_name"
                                :legal_company_name="business_name" label-class="form-label-garden-help"
                                :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"
                                :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"
                                :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12"
                                label-cols="12" content-cols="12">
                    <b-form-input v-if="type == 'register' || type == 'edit'" id="business_name"
                                  class="form-control-garden-help" v-model="_business_name" name="business_name"
                                  placeholder="Business Name"></b-form-input>
                    <span v-if="type == 'view'" class="form-control form-control-garden-help">
                      {{ _business_name }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group class="form-group-garden-help"
                    :label="type != 'view' ? 'Legal Company Name*' : 'Legal Company Name'" label-for="legal_company_name"
                    :legal_company_name="legal_company_name" label-class="form-label-garden-help"
                    :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"
                    :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"
                    :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12"
                    label-cols="12" content-cols="12">
                    <p class="error_validation_message_p_gardenhelp" v-if="invalid_legal_company_name">
                      Please enter company name
                    </p>
                    <b-form-input v-if="type == 'register' || type == 'edit'" id="legal_company_name"
                      class="form-control-garden-help" v-model="_legal_company_name" name="company_legal_name"
                      placeholder="Legal Company Name" required></b-form-input>
                    <span v-if="type == 'view'" class="form-control form-control-garden-help">
                      {{ _legal_company_name }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group class="form-group-garden-help" label="Company Trading Name"
                    label-for="company_trading_name" :company_trading_name="company_trading_name"
                    label-class="form-label-garden-help" :label-cols-xl="type != 'register' ? 3 : 12"
                    :content-cols-xl="type != 'register' ? 9 : 12" :label-cols-lg="type != 'register' ? 4 : 12"
                    :content-cols-lg="type != 'register' ? 8 : 12" :label-cols-md="type != 'register' ? 5 : 12"
                    :content-cols-md="type != 'register' ? 7 : 12" label-cols="12" content-cols="12">
                    <b-form-input v-if="type == 'register' || type == 'edit'" id="company_trading_name"
                      class="form-control-garden-help" v-model="_company_trading_name" name="company_trading_name"
                      placeholder="Company Trading Name"></b-form-input>
                    <span v-if="type == 'view'" class="form-control form-control-garden-help">
                      {{ _company_trading_name ? _company_trading_name : '-' }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group class="form-group-garden-help"
                    :label="type != 'view' ? 'Primary Email Address*' : 'Primary Email Address'"
                    label-for="primary_email_address" :primary_email_address="primary_email_address"
                    label-class="form-label-garden-help" :label-cols-xl="type != 'register' ? 3 : 12"
                    :content-cols-xl="type != 'register' ? 9 : 12" :label-cols-lg="type != 'register' ? 4 : 12"
                    :content-cols-lg="type != 'register' ? 8 : 12" :label-cols-md="type != 'register' ? 5 : 12"
                    :content-cols-md="type != 'register' ? 7 : 12" label-cols="12" content-cols="12">
                    <p class="error_validation_message_p_gardenhelp" v-if="invalid_primary_email_address">
                      Please enter primary email
                    </p>
                    <b-form-input v-if="type == 'register' || type == 'edit'" id="primary_email_address"
                      class="form-control-garden-help" v-model="_primary_email_address" name="primary_email"
                      placeholder="Primary Email Address*" required type="email" @keydown.space.prevent></b-form-input>
                    <span v-if="type == 'view'" class="form-control form-control-garden-help">
                      {{ _primary_email_address }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group class="form-group-garden-help" label="Company Registration Number"
                    label-for="company_registration_number" :company_registration_number="company_registration_number"
                    label-class="form-label-garden-help" :label-cols-xl="type != 'register' ? 3 : 12"
                    :content-cols-xl="type != 'register' ? 9 : 12" :label-cols-lg="type != 'register' ? 4 : 12"
                    :content-cols-lg="type != 'register' ? 8 : 12" :label-cols-md="type != 'register' ? 5 : 12"
                    :content-cols-md="type != 'register' ? 7 : 12" label-cols="12" content-cols="12">
                    <b-form-input v-if="type == 'register' || type == 'edit'" id="company_registration_number"
                      class="form-control-garden-help" v-model="_company_registration_number"
                      name="company_reg_no" placeholder="Company Registration Number"></b-form-input>
                    <span v-if="type == 'view'" class="form-control form-control-garden-help">
                      {{ _company_registration_number ? _company_registration_number : '-' }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group class="form-group-garden-help" label="Company Description" label-for="company_description"
                    :company_description="company_description" label-class="form-label-garden-help"
                    :label-cols-xl="type != 'register' ? 3 : 12" :content-cols-xl="type != 'register' ? 9 : 12"
                    :label-cols-lg="type != 'register' ? 4 : 12" :content-cols-lg="type != 'register' ? 8 : 12"
                    :label-cols-md="type != 'register' ? 5 : 12" :content-cols-md="type != 'register' ? 7 : 12"
                    label-cols="12" content-cols="12">
                    <b-form-textarea v-if="type == 'register' || type == 'edit'" id="company_description"
                      class="form-control-garden-help" v-model="_company_description" name="company_description"
                      placeholder="Company Description" rows="4">
                    </b-form-textarea>

                    <span v-if="type == 'view'" class="form-control form-control-garden-help">
                      {{ _company_description ? _company_description : '-' }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>

<!--        <b-card no-body v-if="type == 'register'">-->
<!--          <b-card-body class="px-2 py-4">-->
<!--            <div class="container">-->
<!--              <b-row>-->
<!--                <b-col sm="12">-->
<!--                  <b-form-group class="form-group-garden-help" label="Choose Service* " label-for="service"-->
<!--                    :service="service" label-class="form-label-garden-help">-->
<!--                    <p class="error_validation_message_p_gardenhelp" v-if="invalid_service">-->
<!--                      Please select service-->
<!--                    </p>-->
<!--                    <v-select v-if="type == 'register' || type == 'edit'" :options="service_options" v-model="_service"-->
<!--                      name="service" title="service" placeholder="Choose service" label="name" :reduce="(item) => item.id"-->
<!--                      :clearable="false" :multiple="true" :closeOnSelect="true" required>-->
<!--                    </v-select>-->
<!--                    <span v-if="type == 'view'" class="form-control form-control-garden-help">-->
<!--                      {{ _service }}-->
<!--                    </span>-->
<!--                  </b-form-group>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--            </div>-->
<!--          </b-card-body>-->
<!--        </b-card>-->
      </b-card-body>
    </b-card>
  </div>
</template>


<script>
import PersonalInfo from "./PersonalInfo.vue";
import SocialMediaInfo from "./SocialMediaInfo.vue";
import WorkInfo from "./WorkInfo.vue";
import SelectSubscription from "@/components/subscriptions/SelectSubscription.vue";

export default {
  name: "ContractorDetails",
  components: { PersonalInfo, SocialMediaInfo, WorkInfo, SelectSubscription },
  props: [
    "type",
    "is_company",
    "legal_company_name",
    "invalid_legal_company_name",
    "company_trading_name",
    "primary_email_address",
    "invalid_primary_email_address",
    "company_registration_number",
    "company_description",
    "service_options",
    "service",
    "invalid_service",
    "business_name"
  ],

  data() {
    return {};
  },
  mounted() { },

  computed: {
    _business_name: {
      get() {
        return this.business_name;
      },
      set(value) {
        this.$emit("update:business_name", value);
      },
    },
    _legal_company_name: {
      get() {
        return this.legal_company_name;
      },
      set(value) {
        this.$emit("update:legal_company_name", value);
      },
    },
    _company_trading_name: {
      get() {
        return this.company_trading_name;
      },
      set(value) {
        this.$emit("update:company_trading_name", value);
      },
    },
    _primary_email_address: {
      get() {
        return this.primary_email_address;
      },
      set(value) {
        this.$emit("update:primary_email_address", value);
      },
    },

    _company_registration_number: {
      get() {
        return this.company_registration_number;
      },
      set(value) {
        this.$emit("update:company_registration_number", value);
      },
    },
    _company_description: {
      get() {
        return this.company_description;
      },
      set(value) {
        this.$emit("update:company_description", value);
      },
    },
    _service: {
      get() {
        return this.service;
      },
      set(value) {
        this.$emit("update:service", value);
      },
    },
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/CompanyDetails.vue